export default "__VITE_ASSET__DEJRIg$e__"